import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["href", "onClick"]
const _hoisted_2 = {
  key: 0,
  class: "tooltip"
}
const _hoisted_3 = { class: "tooltiptext" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    to: _ctx.to,
    custom: ""
  }, {
    default: _withCtx(({ href, route, navigate, isActive, isExactActive }) => [
      _createElementVNode("a", _mergeProps({ href: href }, _ctx.$attrs, {
        onClick: navigate,
        class: ["flex justify-center flex-grow transition-colors duration-300 items-center menu_button", [isExactActive ? 'bg-next-light-gray hover:bg-next-light-gray text-next-orange': 'text-white hover:bg-next-neu']]
      }), [
        _renderSlot(_ctx.$slots, "default", {}, () => [
          _createElementVNode("i", {
            class: _normalizeClass(["text-2xl", _ctx.iconClass])
          }, null, 2)
        ], true),
        (_ctx.tooltip)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
              _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.tooltip), 1)
            ]))
          : _createCommentVNode("", true)
      ], 16, _hoisted_1)
    ]),
    _: 3
  }, 8, ["to"]))
}